import styled from '@emotion/styled';
import Comps from '@owenscorning/react-library';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setAppData } from '../redux/action';

const Container = styled.div`
  .dropzone {
    border: 1px dashed #585858;
    border-radius: 5px;
    padding: 20px;
    text-align: center;
    margin-bottom: 20px;

    svg {
      width: 40px;
      height: 28.33px;
      display: block;
      margin: auto;
    }

    h3,
    h4 {
      display: none;
    }
  }
`;

const { FileWidget } = Comps.Connect;

const defaultMimeTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/gif',
  'image/heic',
];

const ReduxFileWidget = ({
  onChange,
  mimeTypes = defaultMimeTypes,
  multiple = true,
  fileUploadState = {},
  saveFileUploadState,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [fileSize, setFileSize] = useState(0);
  const dispatch = useDispatch();
  const appData = useSelector(state => state.appData);

  const args = {
    areControlsReadonly: false,
    server: MDMS_URL,
  };

  const onFailure = () => console.log('upload failure');

  const { areControlsReadonly } = args;

  return (
    <Container>
      <FileWidget
        multiple={multiple}
        server={args.server}
        onChange={onChange}
        onChangeSize={setFileSize}
        saveFileUploadState={saveFileUploadState}
        fileUploadState={fileUploadState}
        value={['non-empty array']}
        onIsUploading={setIsUploading}
        onFailure={onFailure}
        readOnly={areControlsReadonly}
        mimeTypes={mimeTypes}
        track={{}}
      />
    </Container>
  );
};

export default ReduxFileWidget;
